// Vuetify
import { createVuetify } from 'vuetify'
// Styles
import 'vuetify/styles'

import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          footer: '#f0f0f0',
          black: '#000000',
          primary: '#0069d9',
          primary_dark: '#0054ae',
          grey98: '#FAFAFA',
        },
        variables: {
          notificationBgColor: 'white',
        },
      },
    },
  },
})
